import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { DefaultFormData, FormPickerDatas } from '../../local-types';

interface FormInputListProps extends DefaultFormData {
    value: string;
    inputList: FormPickerDatas[];
}

const FormInputList = ({
    value,
    inputList,
    disabled,
    required,
    placeholder,
    id,
    name,
    label,
    handleChange,
}: FormInputListProps): JSX.Element => {
    const classes = useStyles();

    return (
        <FormControl>
            <div className={classes.formLabel}>{label}</div>
            <TextField
                variant="outlined"
                type="text"
                id={id}
                placeholder={placeholder}
                name={name}
                value={value || ''}
                className={classes.formInput}
                required={required}
                disabled={disabled}
                onChange={handleChange}
                inputProps={{ list: id }}
            />
            <datalist id={id}>
                {inputList.map((select) => {
                    return (
                        <option key={select.id} value={select.name}>
                            {select.name}
                        </option>
                    );
                })}
            </datalist>
        </FormControl>
    );
};

//=====================================//
//=============== Style ===============//
//=====================================//

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formLabel: {
            fontSize: 12,
            color: theme.palette.primary.dark,
            fontWeight: 500,
        },
        formInput: {
            width: '100%',
            minWidth: 200,
            margin: 0 + 'px!important',
            marginTop: 7 + 'px!important',
        },
    }),
);

export default FormInputList;
